export default [
    {
        name: 'word',
        sortField: 'word',
        type: 'string',
        callback: 'similarKeyWord',
        defaultSearch: true,
        useInFilter: true,
    },
    {
        name: 'url',
        sortField: 'url',
        type: 'string',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: '__slot:pos',
        sortField: 'pos',
        type: 'number',
        dataClass: 'ral pos',
        useInFilter: true,
    },
    {
        name: 'ws',
        sortField: 'ws',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        isDefault: true,
        useInFilter: true,
    },
    {
        name: 'wsk',
        sortField: 'wsk',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
        isDefault: true,
    },
    {
        name: 'superwsk',
        sortField: 'superwsk',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
        isDefault: true,
    },
    {
        name: 'numwords',
        sortField: 'numwords',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'adscnt',
        sortField: 'adscnt',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'docs',
        sortField: 'docs',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'avbid',
        sortField: 'avbid',
        type: 'number',
        callback: 'currency',
        dataClass: 'ral avbid',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'serpf',
        sortField: 'serpf',
        type: 'dateRange',
        dataClass: 'ral',
        defaultSearch: false,
        useInFilter: true,
    },
    {
        name: 'isgeo',
        type: 'bool',
        defaultSearch: false,
        useInFilter: true,
        visible: false,
    },
    {
        name: 'isquest',
        type: 'bool',
        defaultSearch: false,
        useInFilter: true,
        visible: false,
    },
    {
        name: '__slot:keys_meta',
        dataClass: 'text-center',
        defaultSearch: false,
        useInFilter: false,
    },

]
